export default __webpack_public_path__ + "static/large-1-763118407884cb2f15e07b2e671db399.png";